// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2UZ-Q","prevNextPageBtn":"styles_prevNextPageBtn__1eEWh","text":"styles_text__32tqC","input":"styles_input__UfASl","select":"styles_select__3Qdyz"};